import { Popover } from "@/app/(components)/Basic/Popover";
import React from "react";

export interface Props {
  id: string;
  onDelete: (id: string) => void;
}

const NftCommentsMorePopover = ({ id, onDelete }: Props) => {
  return (
    <Popover>
      <button onClick={() => onDelete(id)}>Delete</button>
    </Popover>
  );
};

export default NftCommentsMorePopover;
